import { dayjs } from "@outschool/time";

import { useLearnerClassroomContext } from "../providers/LearnerClassroomProvider";

type TeacherSupportSection =
  | {
      is_self_paced?: boolean | null;
      end_time?: string | Date | null;
    }
  | null
  | undefined;

type TeacherSupportSyllabus =
  | {
      layoutVersion?: number | null;
    }
  | null
  | undefined;

// Keep this in sync with Classroom.isWithinSelfPacedV2TeacherSupportWindow()
// in the server code. The learner UI uses the inverse of that helper to hide
// composers proactively for self-paced layout > 1 once section.end_time passes.
export function hasTeacherSupportEnded(
  section: TeacherSupportSection,
  syllabus: TeacherSupportSyllabus,
) {
  if (!section?.is_self_paced) {
    return false;
  }

  if (!syllabus?.layoutVersion || syllabus.layoutVersion <= 1) {
    return false;
  }

  if (!section.end_time) {
    return false;
  }

  return dayjs().isAfter(dayjs(section.end_time));
}

export function useLearnerTeacherSupportEnded() {
  const { section, syllabus } = useLearnerClassroomContext();

  return hasTeacherSupportEnded(section, syllabus);
}
